if (!customElements.get('lazy-video-player')) {
  class LazyVideoPlayer extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    init() {
      const videoSources = this.dataset.videoSources.split(',');
      const poster = this.querySelector('img[data-poster-image]');
      const button = this.querySelector('[data-action="video-play-pause"]');

      let video;

      const createVideoElement = () => {
        video = document.createElement('video');
        video.muted = true;
        video.loop = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('muted', true);
        video.setAttribute('inline', true);
        video.setAttribute('disablepictureinpicture', true);
        
        this.style.zIndex = 0;
        video.className = poster.className;
        poster.style.position = 'absolute';
        poster.style.top = '0';
        poster.style.left = '0';
        poster.style.width = '100%';
        poster.style.height = '100%';
        poster.style.objectFit = 'cover';
        poster.style.transition = 'opacity 0.3s ease-in-out';
        poster.style.zIndex = 1;
        video.style.opacity = 1;
        video.style.objectFit = 'cover';
        video.style.width = '100%';
        video.style.position = 'relative';
        video.style.height = '100%';
        video.style.zIndex = 2;
        button.style.zIndex = 3;

        videoSources.forEach((source) => {
          const sourceElement = document.createElement('source');
          sourceElement.src = source.trim();
          sourceElement.type = source.endsWith('m3u8') ? 'application/x-mpegURL' : 'video/mp4';
          video.appendChild(sourceElement);
        });

        this.style.position = 'relative';
        this.style.overflow = 'hidden';

        this.appendChild(video);
      };

      poster.addEventListener('click', () => {
        if (!video) createVideoElement();
        video.style.opacity = '1';
        video.play();
        button.querySelector('.icon-play').style.display = 'none';
        button.querySelector('.icon-pause').style.display = 'inline';
        button.title = "Pause video";
      });

      button.addEventListener('click', () => {
        if (!video) createVideoElement();
        if (video.paused) {
          video.style.opacity = '1';
          video.play();
          button.querySelector('.icon-play').style.display = 'none';
          button.querySelector('.icon-pause').style.display = 'inline';
          button.title = "Pause video";
        } else {
          video.style.opacity = '0';
          video.pause();
          button.querySelector('.icon-play').style.display = 'inline';
          button.querySelector('.icon-pause').style.display = 'none';
          button.title = "Play video";
        }
      });
    }
  }  
  customElements.define('lazy-video-player', LazyVideoPlayer);
}